<template>
  <div class="message-info-card">
    <div class="info-content" :class="`carrot-${carrotPosition}`" @click.stop>
      <!-- Okuyanlar Başlığı -->
      <div class="status-section">
        <div class="section-header">
          <svg class="section-icon blue-ticks" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <polyline points="3 12 7 16 13 6"></polyline>
            <polyline points="10 12 14 16 20 6"></polyline>
          </svg>
          <span class="section-title">OKUYANLAR</span>
        </div>
        
        <div class="user-list" v-if="readUsers.length > 0">
          <div class="user-item" v-for="user in readUsers" :key="'read-'+user.UserID">
            <div class="user-avatar">
              <img :src="getProcessedUserAvatar(user)" alt="avatar" class="avatar-img">
            </div>
            <div class="user-info">
              <div class="user-name">{{ user.VisibleName || user.NameSurname || user.UserName }}</div>
              <div class="user-status-row">
                <span class="user-status">Okundu</span>
                <span class="user-time">{{ formatDateTimeShort(new Date(user.SeenDate || user.DeliverDate)) }}</span>
              </div>
              <div class="user-status-row">
                <span class="user-status">Teslim edildi</span>
                <span class="user-time">{{ formatDateTimeShort(new Date(user.DeliverDate)) }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="empty-state" v-else>
          <span>Henüz kimse okumadı</span>
        </div>
      </div>
      
      <!-- Teslim Edilenler Başlığı -->
      <div class="status-section">
        <div class="section-header">
          <svg class="section-icon gray-ticks" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <polyline points="3 12 7 16 13 6"></polyline>
            <polyline points="10 12 14 16 20 6"></polyline>
          </svg>
          <span class="section-title">TESLİM EDİLENLER</span>
        </div>
        
        <div class="user-list" v-if="deliveredUsers.length > 0">
          <div class="user-item" v-for="user in deliveredUsers" :key="'delivered-'+user.UserID">
            <div class="user-avatar">
              <img :src="getProcessedUserAvatar(user)" alt="avatar" class="avatar-img">
            </div>
            <div class="user-info user-info-delivered">
              <div class="user-name">{{ user.VisibleName || user.NameSurname || user.UserName }}</div>
              <div class="user-time">{{ formatDateTimeShort(new Date(user.DeliverDate)) }}</div>
            </div>
          </div>
        </div>
        <div class="empty-state" v-else>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GroupMessageInfoCard',
  props: {
    isSender: {
      type: Boolean,
      default: false
    },
    currentMessage: {
      type: Object,
      required: true
    },
    carrotPosition: {
      type: String,
      default: 'middle'  // 'middle', 'bottom', 'top'
    }
  },
  data() {
    return {
      refreshKey: 0
    }
  },
  computed: {
    message() {
      return this.$store.state.display.messageInfoModal && this.$store.state.display.messageInfoModal.message || {}
    },
    isLastMessage() {
      // Mesajın son mesaj olup olmadığını kontrol et
      if (!this.currentMessage || !this.$store.state.message.messages) return false
      
      const messages = this.$store.state.message.messages
      if (messages.length === 0) return false
      
      // Aktif konuşmadaki mesajları filtrele
      const activeConversation = this.$store.state.conversation.activeConversation
      let conversationMessages = messages
      
      if (activeConversation) {
        if (activeConversation.isGroupConversation || activeConversation.GroupID) {
          // Grup mesajları için
          conversationMessages = messages.filter(msg => msg.To === activeConversation.GroupID || msg.To === activeConversation.ConversationID)
        } else {
          // Normal konuşma mesajları için
          conversationMessages = messages.filter(msg => msg.ConversationID === activeConversation.ConversationID)
        }
      }
      
      if (conversationMessages.length === 0) return false
      
      // Mesajları CreateDate'e göre sırala ve son mesajı bul
      const sortedMessages = conversationMessages.sort((a, b) => new Date(a.CreateDate) - new Date(b.CreateDate))
      const lastMessage = sortedMessages[sortedMessages.length - 1]
      
      const isLast = lastMessage && lastMessage.MessageID === this.currentMessage.MessageID
      
      // Debug için console.log ekle
      console.log('GroupMessageInfoCard isLastMessage:', {
        currentMessageID: this.currentMessage.MessageID,
        lastMessageID: lastMessage ? lastMessage.MessageID : 'none',
        isLast: isLast,
        conversationMessagesCount: conversationMessages.length
      })
      
      // Son mesajın ID'si ile mevcut mesajın ID'sini karşılaştır
      return isLast
    },
    // Mesaj durumlarını grupla (refreshKey ile yeniden hesapla)
    messageStatuses() {
      // refreshKey değişikliğini tetiklemek için kullanıyoruz
      this.refreshKey
      const statuses = this.$store.state.messagestatus.messageStatuses.filter(ms => 
        ms.MessageID === this.message.MessageID
      )
      return statuses
    },
    // Okuyan kullanıcılar
    readUsers() {
      // refreshKey değişikliğini zorla
      const key = this.refreshKey
      
      // Store'dan güncel veriyi al
      const currentStatuses = this.$store.state.messagestatus.messageStatuses || []
      
      const readers = currentStatuses
        .filter(ms => {
          const matches = ms.MessageID === this.message.MessageID && ms.Status >= 3
          return matches
        })
        .map(ms => {
          // Kullanıcı bilgilerini ekle
          const user = this.findUserById(ms.UserID)
          // SeenDate yoksa DeliverDate veya UpdateDate kullan
          const seenDate = ms.SeenDate || ms.DeliverDate || ms.UpdateDate
          return {
            ...ms,
            SeenDate: seenDate,
            ...user
          }
        })
        .sort((a, b) => new Date(a.SeenDate || a.DeliverDate || 0) - new Date(b.SeenDate || b.DeliverDate || 0))
      
      return readers
    },
    // Teslim edilen kullanıcılar (okuyanlar hariç)
    deliveredUsers() {
      // refreshKey değişikliğini zorla
      const key = this.refreshKey
      
      // Store'dan güncel veriyi al
      const currentStatuses = this.$store.state.messagestatus.messageStatuses || []
      
      return currentStatuses
        .filter(ms => ms.MessageID === this.message.MessageID && ms.Status === 2 && ms.DeliverDate)
        .map(ms => {
          // Kullanıcı bilgilerini ekle
          const user = this.findUserById(ms.UserID)
          return {
            ...ms,
            ...user
          }
        })
        .sort((a, b) => new Date(a.DeliverDate) - new Date(b.DeliverDate))
    },
    // Bekleyen kullanıcılar
    pendingUsers() {
      // Aktif konuşmadaki tüm kullanıcıları al
      const conversationUsers = this.getConversationUsers()
      
      // Mesaj durumu olmayan kullanıcıları bul
      const pendingUsersList = conversationUsers.filter(user => 
        !this.messageStatuses.some(ms => ms.UserID === user.UserID)
      )
      
      // Mevcut kullanıcıyı listeden çıkar
      return pendingUsersList.filter(user => 
        user.UserID !== this.$store.state.session.user.UserID
      )
    },
    // En erken okunma zamanı
    earliestReadTime() {
      if (this.readUsers.length > 0) {
        const earliestRead = this.readUsers[0]
        return this.formatDateTimeShort(new Date(earliestRead.SeenDate))
      }
      return ''
    },
    // En erken teslim zamanı
    earliestDeliveredTime() {
      // Eğer okuyan varsa onların teslim zamanını göster
      if (this.readUsers.length > 0) {
        const earliestRead = this.readUsers[0]
        return this.formatDateTimeShort(new Date(earliestRead.DeliverDate || earliestRead.SeenDate))
      }
      // Sadece teslim edilenler varsa
      if (this.deliveredUsers.length > 0) {
        const earliestDelivered = this.deliveredUsers[0]
        return this.formatDateTimeShort(new Date(earliestDelivered.DeliverDate))
      }
      return ''
    }
  },
  asyncComputed: {
    async userAvatars() {
      const avatars = {}
      
      // Okuyan kullanıcılar için avatarları yükle
      for (const user of this.readUsers) {
        avatars[user.UserID] = await this.loadUserAvatar(user)
      }
      
      // Teslim edilen kullanıcılar için avatarları yükle
      for (const user of this.deliveredUsers) {
        avatars[user.UserID] = await this.loadUserAvatar(user)
      }
      
      // Bekleyen kullanıcılar için avatarları yükle
      for (const user of this.pendingUsers) {
        avatars[user.UserID] = await this.loadUserAvatar(user)
      }
      
      return avatars
    }
  },
  methods: {
    closeModal() {
      this.$store.state.display.messageInfoModal = {
        isOpen: false,
        message: null
      }
    },
    formatDateTimeShort(date) {
      // Tarih kontrolü
      if (!date || isNaN(new Date(date).getTime())) {
        return 'Geçersiz tarih'
      }
      
      const messageDate = new Date(date)
      const today = new Date()
      const yesterday = new Date(today)
      yesterday.setDate(yesterday.getDate() - 1)
      
      // Saat formatı
      const timeStr = `${messageDate.getHours().toString().padStart(2, '0')}:${messageDate.getMinutes().toString().padStart(2, '0')}`
      
      // Bugün mü kontrol et
      if (messageDate.toDateString() === today.toDateString()) {
        return `Bugün ${timeStr}`
      }
      
      // Dün mü kontrol et
      if (messageDate.toDateString() === yesterday.toDateString()) {
        return `Dün ${timeStr}`
      }
      
      // Diğer günler için tam tarih
      return `${messageDate.getDate().toString().padStart(2, '0')}.${(messageDate.getMonth() + 1).toString().padStart(2, '0')}.${messageDate.getFullYear()}, ${timeStr}`
    },
    handleOutsideClick(event) {
      // Tooltip dışına tıklandığında kapat
      if (this.$el && !this.$el.contains(event.target) && 
          !event.target.closest('.messageMenuItem')) { // Menü öğesine tıklandığında tetiklenmemesi için
        this.closeModal()
      }
    },
    findUserById(userId) {
      // Store'dan getUserById getter'ını kullan
      const userFromStore = this.$store.getters.getUserById(userId)
      if (userFromStore) {
        return userFromStore
      }
      
      // Aktif konuşmadaki kullanıcıları kontrol et
      const conversationUsers = this.getConversationUsers()
      const user = conversationUsers.find(user => user.UserID === userId)
      
      // Kullanıcı bulunamadıysa, tüm kullanıcılar arasında ara
      if (!user) {
        // Tüm konuşmalardaki kullanıcıları kontrol et
        const allConversations = this.$store.state.conversation.conversations || []
        for (const conv of allConversations) {
          if (conv.Buddy && conv.Buddy.UserID === userId) {
            return conv.Buddy
          }
          if (conv.Contact && conv.Contact.UserID === userId) {
            return conv.Contact
          }
        }
        
        // Grup üyeleri arasında ara
        const allGroups = this.$store.state.group.groups || []
        for (const group of allGroups) {
          if (group.Members) {
            const member = group.Members.find(m => m.UserID === userId)
            if (member) return member
          }
        }
      }
      
      return user || { UserID: userId, UserName: 'Kullanıcı ' + userId, VisibleName: 'Kullanıcı ' + userId }
    },
    getConversationUsers() {
      // Aktif konuşma grup ise üyeleri al
      const activeConversation = this.$store.state.conversation.activeConversation
      if (activeConversation) {
        if (activeConversation.Members) {
          return activeConversation.Members
        } else if (activeConversation.Participants) {
          // Grup bilgisini bul
          const group = this.$store.state.group.groups.find(g => g.GroupID === activeConversation.ConversationID)
          if (group) {
            // Katılımcı ve yönetici listelerini birleştir
            const members = []
            
            // Katılımcıları ekle
            if (group.Participants) {
              for (const userId of group.Participants) {
                // Kullanıcı bilgisini bul
                const userInfo = this.getUserInfoFromId(userId)
                if (userInfo) members.push(userInfo)
              }
            }
            
            // Yöneticileri ekle
            if (group.Admins) {
              for (const userId of group.Admins) {
                // Kullanıcı bilgisini bul
                const userInfo = this.getUserInfoFromId(userId)
                if (userInfo) members.push(userInfo)
              }
            }
            
            // Grup sahibini ekle
            if (group.Owner) {
              const ownerInfo = this.getUserInfoFromId(group.Owner)
              if (ownerInfo) members.push(ownerInfo)
            }
            
            return members
          }
        }
      }
      return []
    },
    getUserInfoFromId(userId) {
      // Store'dan getUserById getter'ını kullan
      const userFromStore = this.$store.getters.getUserById(userId)
      if (userFromStore) {
        return userFromStore
      }
      
      // Tüm konuşmalardaki kullanıcıları kontrol et
      const allConversations = this.$store.state.conversation.conversations || []
      for (const conv of allConversations) {
        if (conv.Buddy && conv.Buddy.UserID === userId) {
          return conv.Buddy
        }
        if (conv.Contact && conv.Contact.UserID === userId) {
          return conv.Contact
        }
      }
      return { UserID: userId, UserName: 'Kullanıcı ' + userId, VisibleName: 'Kullanıcı ' + userId }
    },
    getProcessedUserAvatar(user) {
      // Store'dan kullanıcı bilgisini al
      const userFromStore = this.$store.getters.getUserById(user.UserID)
      let photoURL = userFromStore ? userFromStore.PhotoURL : (user.ProfilePhotoUrl || user.PhotoURL)

      if (!photoURL || photoURL === '' || photoURL === null || photoURL === undefined) {
        return '/images/nophoto.png'
      }

      // HTTP URL veya nophoto.png ise direkt döndür
      if (photoURL.includes('http') || photoURL.includes('nophoto.png')) {
        return photoURL
      }

      // Şifrelenmiş dosya URL'si oluştur
      if (this.$config && process.env.VUE_APP_UPLOADURL2) {
        let key = '6a61e395-b49a-4468-bee0-27644e95308f'
        var iv = key
          .split('')
          .reverse()
          .join('')
        let encryptedBody = this.ewk(photoURL, key, iv)
        return process.env.VUE_APP_UPLOADURL2 + '/gfe?fn=' + photoURL + '&s=' + encodeURIComponent(encryptedBody)
      }

      return '/images/nophoto.png'
    }
  },
  watch: {
    // Store'daki messageStatuses değişikliklerini dinle
    '$store.state.messagestatus.messageStatuses': {
      handler(newVal, oldVal) {
        // refreshKey'i artırarak computed property'lerin yeniden hesaplanmasını sağla
        this.refreshKey++
        // DOM güncellemesini zorla
        this.$nextTick(() => {
          this.$forceUpdate()
        })
      },
      deep: true,
      immediate: true
    }
  },
  mounted() {
    // Document'e click event listener ekle
    document.addEventListener('click', this.handleOutsideClick)
    
    // EventBus üzerinden mesaj durumu güncellemelerini dinle
    if (this.$root.$on) {
      this.$root.$on('messageStatusUpdated', (data) => {
        if (data && data.MessageID === this.currentMessage.MessageID) {
          this.refreshKey++
          this.$forceUpdate()
        }
      })
    }
  },
  beforeDestroy() {
    // Component yok edildiğinde listener'ı kaldır
    document.removeEventListener('click', this.handleOutsideClick)
    
    // EventBus listener'ını kaldır
    if (this.$root.$off) {
      this.$root.$off('messageStatusUpdated')
    }
  }
}
</script>

<style lang="less" scoped>
.message-info-card {
  position: relative;
  margin-right: -8px;
  z-index: 1;
}

.info-content {
  background: white;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.15);
  padding: 16px;
  width: 320px;
  border: 1px solid #e0e0e0;
  max-height: 400px;
  display: flex;
  flex-direction: column;
  position: relative;
  
  @media (max-width: 700px) {
    width: 200px;
  }
  
  // Carrot orta konumda (varsayılan)
  &.carrot-middle::after {
    content: '';
    position: absolute;
    right: -8px;
    top: 50%;
    transform: translateY(-50%);
    width: 8px;
    height: 20px;
    background: white;
    clip-path: polygon(0 0, 0 100%, 100% 50%);
    border-right: 1px solid #e0e0e0;
    border-top: 1px solid #e0e0e0;
    border-bottom: 1px solid #e0e0e0;
  }

  &.carrot-middle::before {
    content: '';
    position: absolute;
    right: -1px;
    top: 50%;
    transform: translateY(-50%);
    width: 2px;
    height: 18px;
    background: white;
    z-index: 2;
  }

  // Carrot alt konumda
  &.carrot-bottom::after {
    content: '';
    position: absolute;
    right: -8px;
    bottom: 20px;  // Alttan 20px yukarıda
    width: 8px;
    height: 20px;
    background: white;
    clip-path: polygon(0 0, 0 100%, 100% 50%);
    border-right: 1px solid #e0e0e0;
    border-top: 1px solid #e0e0e0;
    border-bottom: 1px solid #e0e0e0;
  }

  &.carrot-bottom::before {
    content: '';
    position: absolute;
    right: -1px;
    bottom: 20px;  // Alttan 20px yukarıda
    width: 2px;
    height: 18px;
    background: white;
    z-index: 2;
  }

  // Carrot üst konumda
  &.carrot-top::after {
    content: '';
    position: absolute;
    right: -8px;
    top: 20px;  // Üstten 20px aşağıda
    width: 8px;
    height: 20px;
    background: white;
    clip-path: polygon(0 0, 0 100%, 100% 50%);
    border-right: 1px solid #e0e0e0;
    border-top: 1px solid #e0e0e0;
    border-bottom: 1px solid #e0e0e0;
  }

  &.carrot-top::before {
    content: '';
    position: absolute;
    right: -1px;
    top: 20px;  // Üstten 20px aşağıda
    width: 2px;
    height: 18px;
    background: white;
    z-index: 2;
  }
}

.status-section {
  margin-bottom: 20px;
  display: flex;
  flex-direction: column;
  min-height: 0;
  
  &:last-child {
    margin-bottom: 0;
  }
}

.section-header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 12px;
  padding-bottom: 8px;
  border-bottom: 1px solid #f0f0f0;
  flex-shrink: 0;
}

.section-icon {
  width: 16px;
  height: 16px;
  flex-shrink: 0;
  
  &.blue-ticks {
    color: #53bdeb;
  }
  
  &.gray-ticks {
    color: #8696a0;
  }
}

.section-title {
  font-size: 11px;
  font-weight: 600;
  color: #8696a0;
  letter-spacing: 0.5px;
}

.user-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
  overflow-y: auto;
  padding-right: 8px;
  max-height: 150px;
  
  // Zarif scrollbar tasarımı
  &::-webkit-scrollbar {
    width: 4px;
  }
  
  &::-webkit-scrollbar-track {
    background: #f5f5f5;
    border-radius: 2px;
  }
  
  &::-webkit-scrollbar-thumb {
    background: #d0d0d0;
    border-radius: 2px;
    
    &:hover {
      background: #b0b0b0;
    }
  }
}

.user-item {
  display: flex;
  align-items: center;  // flex-start yerine center yapıldı - dikey ortalama
  gap: 10px;
}

.user-avatar {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  overflow: hidden;
  flex-shrink: 0;
}

.avatar-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.user-info {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 2px;
  justify-content: center;  // Dikey ortalama için eklendi
}

// Teslim edilenler için özel stil
.user-info-delivered {
  flex-direction: row;  // Yan yana diz
  justify-content: space-between;  // İsim solda, tarih sağda
  align-items: center;  // Dikey ortala

  .user-name {
    flex: 1;
  }

  .user-time {
    margin-left: 10px;
    flex-shrink: 0;
  }
}

.user-name {
  font-size: 14px;
  font-weight: 500;
  color: #111b21;
}

.user-status-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 12px;
}

.user-status {
  color: #667781;
}

.user-time {
  font-size: 11px;
  color: #8696a0;
  margin-left: auto;
}

.empty-state {
  padding: 8px 0;
  font-size: 13px;
  color: #8696a0;
  font-style: italic;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(5px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style> 